<template>
  <fieldset class="form-group">
    <legend class="fs-6">{{ legend }}</legend>

    <div class="row" style="margin-top: 0.1em">
      <div v-for="option in options" :key="option.code" class="col-12 col-md-6">
        <div class="form-check">
          <label :for="id + option.code" class="form-check-label">{{
            option.name
          }}</label>
          <input
            :id="id + option.code"
            type="checkbox"
            class="form-check-input"
            :value="option.code"
            v-model="value"
          />
        </div>
      </div>
    </div>
  </fieldset>
</template>

<script setup lang="ts">
import { FormProduct } from "@/types/FormProductType";
import { uniqueId } from "underscore";
import { useField } from "vee-validate";
import { computed, onBeforeMount, ref } from "vue";

type Props = {
  legend: string;
  name?: string;
  id?: string;
};

const props = withDefaults(defineProps<Props>(), {
  name: "product_interest",
});

const options = ref<FormProduct[]>([]);
const id = computed(() => props.id ?? uniqueId("cb-"));

onBeforeMount(() => {
  options.value = window.FormGlobals.products.filter(
    (c) => c.in_lead_capture_form
  );
});

const { value } = useField(() => props.name, undefined, { initialValue: [] });
</script>
